import onboardingMessages from '@/messages/onboarding';
import UserPasswordPage from '@/modules/user/UserPasswordPage';
import { resetUserPassword, verifyResetAuthToken } from '@/services/api/requests/user';
import { createFileRoute, redirect } from '@tanstack/react-router';

const PasswordChange = () => {
  const { authToken } = Route.useParams();
  const { email, roles } = Route.useSearch();

  return (
    <UserPasswordPage
      pageTitle={onboardingMessages.resetPassword}
      pageDescription={onboardingMessages.pleaseEnterNewPasswordBelow}
      email={email}
      authToken={authToken}
      userRoles={roles.split(',')}
      verifyTokenCallback={() => verifyResetAuthToken({ token: authToken, email })}
      setPasswordCallback={(password: string) =>
        resetUserPassword({
          email,
          newPassword: password,
          token: authToken,
        })
      }
    />
  );
};

export const Route = createFileRoute('/password-change/$authToken')({
  staticData: { title: 'Change Password' },
  component: PasswordChange,
  validateSearch: (search: Record<string, unknown>): { email: string; roles: string } => ({
    email: search.email as string,
    roles: search.roles as string,
  }),
  beforeLoad: async ({ context: { auth } }) => {
    const isAuthenticated = auth?.isAuthenticated;
    if (isAuthenticated) {
      throw redirect({
        to: '/onboarding/user',
      });
    }
  },
});
